<template>
  <div>
    <Header> Route List </Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mt-3 mb-3 text-left p-3 bg-gray-100 rounded-md !shadow relative">
        <form class="!mb-0" @submit="onSubmit" novalidate="true">
          <div class="flex items-center gap-3">
            <input class="w-full rounded-md !shadow !border border-gray-100 outline-none text-md px-3 py-2 placeholder-gray-400 disabled:bg-gray-100"
              ref="searchInput"
              type="text"
              v-model="query.search"
              placeholder="Search..."
            />
            <button
              type="submit"
              class="rounded-full bg-white shadow-sm h-10 w-10 p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </div>
          <div class="flex items-center justify-between mt-3 mb-2">
            <div class="flex gap-4">
              <Input
                ref="dateInput"
                class="rounded-md shadow-sm"
                type="date"
                v-model="query.date"
                @input="onSelectDate"
              />
              <Input
                ref="timeInput"
                class="rounded-md shadow-sm"
                type="time"
                v-model="query.time"
                @input="onSelectTime"
              />
              <button
                type="button"
                class="rounded-full bg-white shadow-sm h-10 w-10 p-2"
                @click="clearFilters"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="flex flex-row">
              <div class="mt-3 mr-2 align-middle">Refresh status:</div>
              <SelectionField
                v-model="statusRefresh"
                :options="{
                  1: 'Every 1 minute',
                  5: 'Every 5 minutes',
                  0: 'Never',
                }"
                :defaultValue="5"
              >
              </SelectionField>
            </div>
          </div>
        </form>
        <div class="flex gap-4 flex-wrap">
          <FilterSelector
            v-for="(filterObj, index) in filterUis"
            :key="index"
            :name="filterObj.name"
            :text="filterObj.text"
            :selectedFilter="selectedFilter[filterObj.name]"
            @setSelectedFilter="setSelectedFilter(filterObj.name, $event)"
            :placeholderText="filterObj.placeholderText"
            :filterOptions="filterOptions[filterObj.name]"
            :optionDisplay="filterObj.option.display"
            :checkBox="filterObj.name === 'delayed'">
            <template #text>
              {{ filterObj.text }}
            </template>
            <template #options>
              <option
                v-for="(filterOption, index) in filterOptions[filterObj.name]"
                :key="index"
                :value="filterOption[filterObj.option.value]">
                {{ filterOption[filterObj.option.display] }}
              </option>
            </template>
          </FilterSelector>
        </div>
        <div class="clock-timer">
          Last refresh: {{ lastRefresh }}
        </div>
      </div>
      <div class="flex relative justify-center items-center mt-4">
        <Pagination :pages="pages" to="/RouteList" />
        <div class="absolute right-0 text-gray-400 mt-1 text-sm">
          Total Routes: {{ totalRoutes }}
        </div>
      </div>
      <Spinner
        v-if="displayLoadingRoutesSpinner"
        message="Loading Routes"
        :size="16"
      />
      <Table class="relative left-[calc(-50vw+50%)] w-[100vw]">
        <template #columns>
          <th
            v-for="(column, index) in displayedColumns"
            :key="index"
            scope="col"
            class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
          >
            <Sort v-if="column.sortable"
              class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
              :key="index"
              :name="column.name"
              :outlined="false"
              :selectedSort="selectedSort"
              @setSelectedSort="selectedSort = $event"
            >
              {{ column.text }}
            </Sort>
            <div v-else>
              {{ column.text }}
            </div>
          </th>
        </template>
        <template #rows>
          <RouteItem v-for="(item, index) in routes"
          :key="index"
          :item="item"
          :date="query.date"
          :weekday="weekday"
          :showOriginTime="showOriginTime"
          :showDestinationTime="showDestinationTime"
          :showRouteDetail="showRouteDetail"
          :showNumber="showNumber"
          :showDelayed="showDelayed"
          :showRouteTimes="showRouteTimes"
          :showStatus="showStatus"
          :isPreviousDay="isPreviousDay" />
        </template>
      </Table>
      <div class="flex justify-center pb-4" v-if="routes.length > 0">
        <Pagination :pages="pages" to="/RouteList" />
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
.clock-timer {
  position: absolute;
  right: 5;
  bottom: -1.5rem;
  color: #616060;
  font-size: 14px;
  margin-top: 5px;
}
</style>

<script>
import RouteItem from '../components/items/RouteItem.vue'
import Input from '../components/Input.vue'
import Table from '../components/Table.vue'
import Main from '../components/Main.vue'
import Header from '../components/Header.vue'
import Pagination from '../components/Pagination.vue'
import Sort from '../components/Sort.vue'
import Spinner from '../components/Spinner.vue'
import SelectionField from '../components/formComponents/SelectionField.vue'
import FilterSelector from '../components/FilterSelector.vue'

import routeListService from '../services/pages/routeList.js'

import user from '../services/user/user.js'
import view from '../services/user/view.js'
import time from '../services/utils/time.js'
import events from '../services/events.js'

import DROPDOWN_LISTS from '../components/DropdownLists.json'
import { forOwn, omit, isEqual, isEmpty } from 'lodash'
import fastDeepEquals from 'fast-deep-equal'

const WEEKDAY_MAP = {
  0: 'sun',
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat',
}

function getWeekdayString(date) {
  let dateNumber
  if (date === undefined) {
    dateNumber = (new Date()).getUTCDay()
  }
  else {
    dateNumber = (new Date(`${date}T00:00:00.000Z`)).getUTCDay()
  }
  return WEEKDAY_MAP[dateNumber]
}

function createFilterQueryParam(selectedFilter) {
  let filterQueryParam = ''
  for (const [key, selected] of Object.entries(selectedFilter)) {
    if (!isEmpty(selected)) {
      if (filterQueryParam) {
        filterQueryParam += ';'
      }
      filterQueryParam += `${key}=${selected.join(',')}`
    }
  }
  if (filterQueryParam) {
    return encodeURIComponent(filterQueryParam)
  }
}

export default {
  name: 'RouteList',
  components: {
    RouteItem,
    Input,
    Table,
    Main,
    Header,
    Pagination,
    Sort,
    Spinner,
    SelectionField,
    FilterSelector,
  },
  data() {
    return {
      user: undefined,
      view: undefined,
      totalRoutes: 0,
      schoolYear: undefined,
      showNumber: false,
      showDelayed: true,
      selectedSort: {
        name: '',
        descending: false,
      },
      routes: [],
      query: {
        search: '',
        date: undefined,
        time: undefined,
      },
      searchInput: undefined,
      displayLoadingRoutesSpinner: false,
      cache: {},
      pages: {},
      numPerPage: 25,
      timerCount: 0,
      lastRefresh: new Date().toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
      }),
      statusRefresh: 0,
      weekday: 0,
      selectedFilter: {},
      filterOptions: {
        status: [
          { code: 'not_started', text: 'Not started' },
          { code: 'running', text: 'In progress' },
          { code: 'complete', text: 'Completed' },
        ],
        delayed:[
          { code: 'true', text: 'Delayed' },
          { code: 'false', text: 'Not Delayed' },
        ],
        routeDirection: [
          { code: 'inbound', text: 'Inbound' },
          { code: 'outbound', text: 'Outbound' },
        ]
      },
      filterUis: [
        {
          name: 'status',
          text: 'Driven Status',
          option: {
            value: 'code',
            display: 'text'
          }
        },
        {
          name: 'delayed',
          text: 'Delayed',
          option: {
            value: 'code',
            display: 'text'
          }
        },
        {
          name: 'routeDirection',
          text: 'Direction',
          option: {
            value: 'code',
            display: 'text'
          }
        },
      ],
      columns: [
        {
          name: 'vehicle__code',
          text: 'Vehicle',
          sortable: true,
        },
        // {
        //   name: 'route__window_sign',
        //   text: 'Window Sign',
        //   sortable: true,
        // },
        {
          name: 'route__number',
          text: 'Route Number',
          sortable: true,
        },
        {
          name: 'routeDirection',
          text: 'Direction',
          sortable: true,
        },
        {
          name: 'status',
          text: 'Status',
          sortable: false,
        },
        {
          name: 'building',
          text: 'Building',
          sortable: true,
        },
        {
          name: 'details',
          text: 'Details',
          sortable: false,
        },
        {
          name: undefined,
          text: 'Start Time',
          sortable: true,
        },
        {
          name: undefined,
          text: 'End Time',
          sortable: true,
        },
        {
          name: 'schedule',
          text: 'Schedule',
          sortable: false,
        },
        {
          name: 'accommodations',
          text: 'Accommodations',
          sortable: false,
        },
        {
          name: 'students',
          text: 'Students',
        },
      ]
    }
  },
  eventCallbackIds: {},
  methods: {
    async setRouteData() {
      this.view = await view.get()

      this.numPerPage = routeListService.getNumPerPage()
      this.schoolYear = this.view.getSchoolYear()

      let apiParams = {
        date: this.query.date,
        time: this.query.time,
        perPage: this.numPerPage,
        page: this.$route.query.page,
        search: this.query.search,
        sortBy: this.selectedSort.name
          ? ((this.selectedSort.descending ? '-' : '') + this.selectedSort.name)
          : '',
        filterBy: createFilterQueryParam(this.selectedFilter),
      }

      let routesData
      try {
        this.displayLoadingRoutesSpinner = true
        routesData = (await routeListService.getRouteDataFromServer(apiParams)).data
        this.displayLoadingRoutesSpinner = false
      }
      catch {
        this.displayLoadingRoutesSpinner = false
        return
      }

      this.pages = routesData.pages
      this.routes = routesData.content.main

      for (let dateRoute of routesData.content.date_data) {
        const routeIndex = this.routes.findIndex(r => r.route.db_id == Number(dateRoute.route_id))
        const route = this.routes[routeIndex]
        for (let event of dateRoute.events) {
          if (route !== undefined) {
            if (event.event_type == 'O') {
              let anyStudentNotApply = false
              for (let studentData of route.studentData) {
                let grade = studentData.grade
                if (grade === undefined) continue

                if (!(grade >= event.low_grade && grade <= event.high_grade)) {
                  anyStudentNotApply = true
                  break
                }
              }
              if (!anyStudentNotApply) {
                this.$set(route, 'event', true)
                this.$set(route, 'status', 'off')
              }
            }
          }
        }
        for (let noRide of dateRoute.no_rides) {
          const student = route.studentData[route.studentData.findIndex(e => e.dbId == noRide.student.db_id)]
          if (student !== undefined) {
            this.$set(student, 'noRide', true)
          }
        }
      }
      for (const route of this.routes) {
        let studentCount = 0
        for (const studentData of route.studentData) {
          if (studentData.noRide) {
            studentCount += 1
          }
        }
        if (studentCount >= route.studentData.length) {
          this.$set(route, 'event', true)
          this.$set(route, 'status', 'no_riders')
        }
      }

      if (this.isAfterToday(this.query.date)) {
        for (let route of this.routes) {
          if (route.status === undefined) {
            this.$set(route, 'status', 'not_started')
            this.$set(route, 'delayed', false)
          }
        }
      }
      else {
        for (let transient of routesData.content.transient) {
          const routeIndex = this.routes.findIndex(r => r.route.db_id == Number(transient.route_id))
          const route = this.routes[routeIndex]
          if (route) {
            if (route.status !== 'off' && route.status !== 'no_riders') {
              this.$set(route, 'status', transient.status)
              this.$set(route, 'delayed', transient.delay > 0)
            }
          }
        }
        for (let route of this.routes) {
          if (route.status === undefined || route.status === 'error') {
            console.warn(`Route Status == undefined/"error": ${route.route.number}`, route)
            this.$set(route, 'status', route.status)
            this.$set(route, 'delayed', false)
          }
        }
      }

      this.weekday = (new Date(`${this.query.date}T00:00:00.000Z`)).getUTCDay()
      this.totalRoutes = routesData.page_data.num_routes

      //    Not certain if the UI should poll for updates immediately. The data should already be present.
      // await this.updateStatus()
    },
    setQuerySearch(search) {
      if (Object.hasOwn(this.$route.query, 'search')) {
        this.query.search = search
      }
      else {
        delete this.query.search
      }
    },
    setQueryDate(date) {
      if (Object.hasOwn(this.$route.query, 'date')) {
        this.query.date = date
      }
      else {
        delete this.query.date
      }
    },
    setQueryPage(page) {
      if (Object.hasOwn(this.$route.query, 'page')) {
        this.query.page = page
      }
      else {
        delete this.query.page
      }
    },
    setQueryTime(time) {
      if (Object.hasOwn(this.$route.query, 'time')) {
        this.query.time = time
      }
      else {
        delete this.query.time
      }
    },
    setQueryFilters(filters) {
      if (Object.hasOwn(this.$route.query, 'filters')) {
        this.query.filters = filters
        this.selectedFilter = {}

        const filterArray = filters.split(';')
        for (const ftr of filterArray) {
          const [key, valuesString] = ftr.split('=')
          this.$set(this.selectedFilter, key.trim(), [])
          if (key === 'delayed') {
            this.selectedFilter[key].push(true)
          }
          else {
            const valuesArray = valuesString.split(',')
            for (const value of valuesArray) {
              this.selectedFilter[key].push(value.trim())
            }
          }
        }
      }
      else {
        delete this.query.filters
      }
    },
    updateQueryParams(queryObj) {
      if (!fastDeepEquals(queryObj, this.$route.query)) {
        this.$router.push({
          query: queryObj
        })
        return true
      }
      else {
        return false
      }
    },
    clearFilters() {
      this.query.date = time.today()
      this.query.search = ''
      this.query.time = ''
      this.setFiltersQuery()
    },
    onSelectDate() {
      this.setFiltersQuery()
    },
    onSelectTime() {
      this.setFiltersQuery()
    },
    setFiltersQuery() {
      let queryObj = {
        query: {
          ...this.$route.query
        }
      }
      if (this.query.search) {
        queryObj.query.search = this.query.search
      }
      else {
        delete queryObj.query.search
      }

      if (this.query.time) {
        queryObj.query.time = this.query.time
      }
      else {
        delete queryObj.query.time
      }

      if (this.query.date) {
        if (queryObj.query.date || this.query.date !== time.today()) {
          queryObj.query.date = this.query.date
        }
        else {
          delete queryObj.query.date
        }
      }
      else {
        delete queryObj.query.date
      }

      if (this.query.filters) {
        queryObj.query.filters = this.query.filters
      }
      else {
        delete queryObj.query.filters
      }

      this.updateQueryParams(queryObj.query)
    },
    setSearchQueryFromQueryParams() {
      forOwn(this.$route.query, (value, key) => {
        switch (key) {
          case 'search':
            this.searchInput = value
            this.setQuerySearch(value)
            break
          case 'date':
            this.setQueryDate(value)
            break
          case 'page':
            this.setQueryPage(value)
            break
          case 'time':
            this.setQueryTime(value)
            break
          case 'sortByName':
            this.selectedSort.name = value
            break
          case 'sortByDescending':
            this.selectedSort.descending = value === 'true'
            break
          case 'filters':
            this.setQueryFilters(value)
            break
        }
      })
      if (!Object.hasOwn(this.$route.query, 'search')) {
        delete this.query.search
      }
      if (!Object.hasOwn(this.$route.query, 'date')) {
        this.query.date = time.today()
      }
      if (!Object.hasOwn(this.$route.query, 'time')) {
        this.query.time = undefined
      }
    },
    onFiltersUpdated() {
      this.setFiltersQuery()
    },
    async updateStatus() {
      if (this.isAfterToday(this.query.date)) {
        for (let route of this.routes) {
          if (route.status === undefined) {
            this.$set(route, 'status', 'not_started')
            this.$set(route, 'delayed', false)
          }
        }
      }
      else {
        let routeDataList = this.routes.map(route => {
          return { "route_id": route.route.db_id, "direction": route.routeDirection }
        })
        let statusList = await routeListService.getRouteStatus({ route_list: routeDataList, date: this.query.date })
        statusList = statusList.data

        for (let i = 0; i < this.routes.length; i++) {
          const statusObj = statusList.find(e => e.route_id == this.routes[i].route.db_id)
          if (this.routes[i].schedule[getWeekdayString(this.query.date)] == undefined) {
            this.$set(this.routes[i], 'status', 'not_started')
            this.$set(this.routes[i], 'delayed', false)
          }
          else if (statusObj) {
            this.$set(this.routes[i], 'status', statusObj.status)
            this.$set(this.routes[i], 'delayed', statusObj.delayed)
          }
          else {
            this.$set(this.routes[i], 'status', undefined)
            this.$set(this.routes[i], 'delayed', false)
          }
        }
      }
    },
    setSelectedFilter(filterName, selectedValues) {
      this.selectedFilter[filterName] = selectedValues
      let filterQueryParam = ''
      for (const [key, selected] of Object.entries(this.selectedFilter)) {
        if (!isEmpty(selected)) {
          if (filterQueryParam) {
            filterQueryParam += ';'
          }
          filterQueryParam += `${key}=${selected.join(',')}`
        }
      }
      this.query.filters = filterQueryParam

      this.setFiltersQuery()
    },
    updateQuery(current) {
      let hasChanges = false
      let queryObj = {
        startDate: this.$route.query.startDate,
        endDate: this.$route.query.endDate,
        search: this.$route.query.search,
        filters: this.$route.query.filters,
        ...this.$route.query
      }

      if (current.startDate !== this.$route.query.startDate) {
        hasChanges = true
        queryObj.startDate = current.startDate
      }
      if (current.endDate !== this.$route.query.endDate) {
        hasChanges = true
        queryObj.endDate = current.endDate
      }
      if (current.search !== this.$route.query.search) {
        hasChanges = true
        if (current.search) {
          queryObj.search = current.search
        }
        else {
          delete queryObj.search
        }
      }
      if (current.filters !== this.$route.query.filters) {
        hasChanges = true
        if (current.filters) {
          queryObj.filters = current.filters
        }
        else {
          delete queryObj.filters
        }
      }

      if (hasChanges) {
        if (!isEqual(this.$route.query, queryObj)) {
          this.$router.push({
            query: queryObj
          })
        }
      }
    },
    onSubmit(submitEvent) {
      submitEvent.preventDefault()

      this.onFiltersUpdated()
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_route_list')) {
        if (this.user.can('view_vendor_forms')) {
          this.$router.push({
            name: 'VendorForms'
          })
        }
        else {
          this.$router.push({
            path: '/'
          })
        }
        return true
      }
    },
    isAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const inputDate = new Date(date)
      return inputDate > today
    }
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    if (this.user.can('view_internal_cst_data')) {
      this.showNumber = true
    }
    else {
      this.columns.splice(this.columns.findIndex(e => e.name == 'route__number'), 1)
    }

    if (!this.user.can('view_route_map')) {
      this.columns.splice(this.columns.findIndex(e => e.name == 'map'), 1)
    }

    if (this.user.can('filter_route_on_error')) {
      this.filterOptions.status.push({
        code: 'error',
        text: 'Error',
      })
    }

    this.columns[this.columns.findIndex(e => e.text == 'Start Time')].name = `schedule__${getWeekdayString(this.query.date)}__start_time`
    this.columns[this.columns.findIndex(e => e.text == 'End Time')].name = `schedule__${getWeekdayString(this.query.date)}__end_time`

    this.$options.eventCallbackIds.listPageSettingsUpdate =
      events.register('listPageSettingsUpdate', (currNumPerPage, schoolYear) => {
      if (this.numPerPage != currNumPerPage || this.schoolYear != schoolYear) {
        this.setRouteData()
      }
    })
    this.$options.eventCallbackIds.viewUpdated = events.register('viewUpdated', async () => {
      this.setRouteData()
    })

    this.setSearchQueryFromQueryParams()
    this.setRouteData()
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove('listPageSettingsUpdate', this.$options.eventCallbackIds.listPageSettingsUpdate)
    events.remove('viewUpdated', this.$options.eventCallbackIds.viewUpdated)
  },
  computed: {
    schoolYearDisplay() {
      if (this.schoolYear) {
        return DROPDOWN_LISTS.schoolYears[this.schoolYear]
      } else {
        return ''
      }
    },
    showOriginTime() {
      if (this.user === undefined) {
        return false
      }
      return this.user.can('view_internal_cst_data')
    },
    showDestinationTime() {
      if (this.user === undefined) {
        return false
      }
      return this.user.can('view_internal_cst_data')
    },
    showRouteDetail() {
      if (this.user === undefined) {
        return false
      }
      return this.user.can('view_route_map')
    },
    showRouteTimes() {
      if (this.user === undefined) {
        return false
      }
      return this.user.can('view_route_stop_times')
    },
    isPreviousDay() {
      if (!this.query.date) {
        return false
      }

      return this.query.date < time.today()
    },
    showStatus() {
      if (!this.isPreviousDay) {
        return true
      }

      if (this.user === undefined) {
        return false
      }

      return this.user.can('show_previous_route_status')
    },
    displayedColumns() {
      if (this.showStatus) {
        return this.columns
      }

      return this.columns.filter(column => column.name !== 'status')
    },
  },
  watch: {
    '$route.query': function () {
      this.setSearchQueryFromQueryParams()
      this.setRouteData()
    },
    timerCount: {
      handler(value) {
        if (value >= 0) {
          let timer = setTimeout(() => {
            this.timerCount++;
          }, 1000)

          if (this.timerCount >= 60 && this.statusRefresh == 1) {
            this.updateStatus()
            clearTimeout(timer)
            this.timerCount = 0
            this.lastRefresh = new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
          }
          if (this.timerCount >= 300 && this.statusRefresh == 5) {
            this.updateStatus()
            clearTimeout(timer)
            this.timerCount = 0
            this.lastRefresh = new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
          }
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    selectedSort: {
      handler() {
        let query = omit(this.$route.query, ['sortByName', 'sortByDescending'])
        if (this.selectedSort.name) {
          query.sortByName = this.selectedSort.name
          query.sortByDescending = this.selectedSort.descending
        }
        const queryCompare = {
          ...query,
          sortByDescending: query.sortByDescending ? 'true' : 'false'
        }
        if (!isEqual(this.$route.query, queryCompare)) {
          this.$router.replace({
            query: query
          })
        }
      },
      deep: true
    },
  }
}
</script>

<style></style>
